import ButtonSponsored from '../../buttonSponsored';
import './footerCardF1.sass';

/**
 * Muestra el botón de "Juega aquí" en la tarjeta de Fórmula 1,
 * enlazando a la página del patrocinador si hay información disponible.
*/
export default function FooterCardF1({ data, patrocinador }) {
  // Se obtiene la metadata específica del patrocinador
  const patrocinadorKey = patrocinador?.toLowerCase() || "";
  const metadata = data[`${patrocinadorKey}_metadata`] || {};

  return (
    <ButtonSponsored url ={metadata.url_mm_evento} buttonClass={"card-f1__footer-momios"} wrapperClass={"card-f1__footer"} patrocinador={patrocinador}/>
  )
}